<template>
    <div>
      <taxPaymentsApportionment/>
    </div>
</template>

<script>
import taxPaymentsApportionment from '../../components/apportionment/taxes/taxes.vue';

export default {
  name: 'apportionment',
  data: () => ({

  }),
  components: {
    taxPaymentsApportionment,
  },
};
</script>
